export default __webpack_public_path__ + "static/media/contact.91b59aba.png";